export enum StorageKey {
  Logout = 'logout',
}
